import * as React from 'react';
import { actions } from 'react-redux-form';

import { PlantModel } from '../../model/PlantModel';
import { dispatch } from '../../utils/generalUtils';
import { BoxInput } from '../reusableComponents/FormComponents/BoxInput';
import { Form } from '../reusableComponents/FormComponents/Form';
import { FormFooter } from '../reusableComponents/FormComponents/FormFooter';
import { RRFInput } from '../reusableComponents/FormComponents/RRFInput';
import { inspectionType } from '../../constants/generals';
export interface IPlantFormProps {
    plantInstance?: PlantModel;
    model: string;
    onSubmit: (values) => void;
}

export interface IPlantFormState {
    outFalls: number[];
    inspections: number[];
    inspectionsStrings: string[];
}

export class PlantForm extends React.Component<IPlantFormProps, IPlantFormState> {

    constructor(props: IPlantFormProps) {
        super(props);
        this.state = {
            outFalls: props.plantInstance ? this.populateBoxes(props.plantInstance.props.Outfalls, 'Outfalls') : [],
            inspections: props.plantInstance ?
                this.populateBoxes(props.plantInstance.props.Inspections, 'Inspections') : [],
            inspectionsStrings: props.plantInstance ?
                this.populateBoxes(props.plantInstance.props.Inspections, 'Ins') : []
        };
        dispatch(actions.change(`${props.model}.Country`, 'USA'));
    }

    populateBoxes = (obj, model) => {
        const activeIndexes = [];
        const activeLabels = [];
        let i = 0;
        for (const key in obj) {
            if (obj[key]) {
                activeIndexes.push(i);
                activeLabels.push(key);

                if (model === 'Outfalls') {
                    dispatch(actions.push(`${this.props.model}.${model}`, `Outfall${i + 1}`));
                } else if (model === 'Inspections') {
                    dispatch(actions.push(`${this.props.model}.${model}`, key));
                }
                i++;
                continue;
            }
            i++;
        }
        if (model === 'Ins') {
            return activeLabels;
        }
        return activeIndexes;
    }

    loadValues = () => {
        const { props } = this;
        this.setState({
            outFalls: props.plantInstance ? this.populateBoxes(props.plantInstance.props.Outfalls, 'Outfalls') : [],
            inspections: props.plantInstance ?
                this.populateBoxes(props.plantInstance.props.Inspections, 'Inspections') : [],
            inspectionsStrings: props.plantInstance ?
                this.populateBoxes(props.plantInstance.props.Inspections, 'Ins') : []
        });
    }

    render() {
        const { plantInstance } = this.props;
        return (
            <Form
                loadDefaultValues={this.loadValues}
                model={this.props.model}
                onSubmit={this.props.onSubmit}
                className=""
            >
                <RRFInput
                    model=".PlantId"
                    type="text"
                    placeholder="Enter plant id..."
                    id="PlantId"
                    label="Plant ID:"
                    defaultValue={plantInstance && plantInstance.props.PlantId}
                />
                <RRFInput
                    model=".Plant_Region"
                    type="dropdown"
                    placeholder="Select plant region..."
                    id="PlantRegion"
                    menuItems={[{
                        label: 'Arkansas', value: 'Arkansas'
                    },
                    {
                        label: 'DFW', value: 'DFW'
                    },
                    {
                        label: 'Houston', value: 'Houston'
                    }
                    ]}
                    label="Plant Region:"
                    defaultValue={plantInstance && plantInstance.props.Plant_Region}
                />
                <RRFInput
                    model=".Plant_Name"
                    type="text"
                    placeholder="Enter plant name..."
                    id="plantName"
                    label="Plant Name:"
                    defaultValue={plantInstance && plantInstance.props.Plant_Name}
                />
                <RRFInput
                    model=".Street"
                    type="text"
                    placeholder="Enter plant street..."
                    id="street"
                    label="Street:"
                    defaultValue={plantInstance && plantInstance.props.Street}
                />
                <RRFInput
                    model=".City"
                    type="text"
                    placeholder="Enter plant city..."
                    id="City"
                    label="City:"
                    defaultValue={plantInstance && plantInstance.props.City}
                />
                <RRFInput
                    model=".State"
                    type="text"
                    placeholder="Enter plant state..."
                    id="state"
                    label="State:"
                    defaultValue={plantInstance && plantInstance.props.State}
                />
                <RRFInput
                    model=".Zip"
                    type="number"
                    placeholder="Enter zip code..."
                    id="Zip"
                    label="Zip:"
                    defaultValue={plantInstance && plantInstance.props.Zip.toString()}
                />
                <RRFInput
                    model=".Country"
                    type="text"
                    placeholder="Enter plant country..."
                    id="Country"
                    disabled={true}
                    label="Country:"
                    defaultValue={'USA'}
                />
                <div className="box-input-form" >
                    <BoxInput
                        label="Inspections"
                        labelArray={[ inspectionType('DailyForm'), inspectionType('DailyPlantPreventive'), inspectionType('MonthlySPCC'), inspectionType('MonthlySpillLogs'), inspectionType('MonthlySW'), inspectionType('MonthlyUSTRect'), inspectionType('MonthlyUSTSpill'), inspectionType('QTRVisual'), inspectionType('ShopInspection') ]}
                        activeIndexes={this.state.inspections}
                        activeLabels={this.state.inspectionsStrings}
                        type=""
                        id=""
                        model={`${this.props.model}.Inspections`}
                        onClick={null}

                    />
                    <BoxInput
                        label="Outfalls"
                        labelArray={['Outfall 1', 'Outfall 2', 'Outfall 3', 'Outfall 4', 'Outfall 5', 'Outfall 6']}
                        activeIndexes={this.state.outFalls}
                        activeLabels={this.state.inspectionsStrings}
                        type="Outfalls"
                        id="Outfalls"
                        limitSelectionTo={5}
                        model={`${this.props.model}.Outfalls`}
                        onClick={null}

                    />
                </div>
                <FormFooter />
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Maintenance/PlantForm.tsx